module.exports = __webpack_public_path__ + "img/头像.c00cf577.png";